
// const API_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:8000";

// /*
//  * ============================================================
//  * GET CAMPAIGNS
//  * ============================================================
//  *
//  * Backend:
//  * GET /api/job-management/campaigns
//  *
//  * Used by:
//  * JobsManagement.js
//  */
// export const getCampaigns = async () => {
//   const storedUser =
//     localStorage.getItem("user") ||
//     localStorage.getItem("localUser");

//   const user = storedUser
//     ? JSON.parse(storedUser)
//     : null;

//   if (!user?.id) {
//     throw new Error(
//       "User session not found. Please login again."
//     );
//   }

//   const response = await fetch(
//     `${API_URL}/api/campaigns`,
//     {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "X-User-Id": String(user.id),
//       },
//       credentials: "include",
//     }
//   );

//   if (!response.ok) {
//     let errorMessage = "Failed to fetch campaigns.";

//     try {
//       const errorData = await response.json();

//       errorMessage =
//         errorData.detail ||
//         errorData.message ||
//         errorMessage;
//     } catch (error) {
//       // Response was not JSON
//     }

//     throw new Error(errorMessage);
//   }

//   return await response.json();
// };

// /*
//  * ============================================================
//  * GET REQUESTS / JOBS
//  * ============================================================
//  *
//  * Backend:
//  * GET /api/job-management/requests
//  *
//  * Used by:
//  * JobsManagement.js
//  */
// export const getRequests = async (
//   filters = {},
//   onPageData
// ) => {
//   const response = await fetch(
//     `${API_URL}/api/job-management/requests`,
//     {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       credentials: "include",
//     }
//   );

//   if (!response.ok) {
//     let errorMessage = "Failed to fetch jobs.";

//     try {
//       const errorData = await response.json();

//       errorMessage =
//         errorData.detail ||
//         errorData.message ||
//         errorMessage;
//     } catch (error) {
//       // Response was not JSON
//     }

//     throw new Error(errorMessage);
//   }

//   const responseData = await response.json();

//   const requests =
//     responseData.data || responseData || [];

//   if (typeof onPageData === "function") {
//     onPageData(
//       requests,
//       1,
//       true
//     );
//   }

//   return requests;
// };

// /*
//  * ============================================================
//  * ASSIGN JOBS TO CAMPAIGN
//  * ============================================================
//  *
//  * Backend:
//  * POST /api/job-management/assign
//  *
//  * Request:
//  * {
//  *   campaign_id: 19,
//  *   request_ids: [10382, 10383, 10384]
//  * }
//  *
//  * Backend will update:
//  * requests.campaign_id = 19
//  * for the selected request IDs.
//  */
// export const assignJobsToCampaign = async ({
//   campaign_id,
//   request_ids,
// }) => {
//   if (!campaign_id) {
//     throw new Error("Campaign ID is required.");
//   }

//   if (!Array.isArray(request_ids) || request_ids.length === 0) {
//     throw new Error("At least one job must be selected.");
//   }

//   const response = await fetch(
//     `${API_URL}/api/job-management/assign`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       credentials: "include",
//       body: JSON.stringify({
//         campaign_id: Number(campaign_id),
//         request_ids: request_ids.map((id) => Number(id)),
//       }),
//     }
//   );

//   if (!response.ok) {
//     let errorMessage = "Failed to assign jobs.";

//     try {
//       const errorData = await response.json();
//       errorMessage =
//         errorData.detail ||
//         errorData.message ||
//         errorMessage;
//     } catch (error) {
//       // Response was not JSON
//     }

//     throw new Error(errorMessage);
//   }

//   return await response.json();
// };


const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

/*
 * ============================================================
 * GET CAMPAIGNS
 * ============================================================
 *
 * Backend:
 * GET /api/job-management/campaigns
 *
 * Used by:
 * JobsManagement.js
 */
export const getCampaigns = async () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser
    ? JSON.parse(storedUser)
    : null;

  if (!user?.id) {
    throw new Error(
      "User session not found. Please login again."
    );
  }

  const response = await fetch(
    `${API_URL}/api/job-management/campaigns`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-User-Id": String(user.id),
      },
      credentials: "include",
    }
  );

  if (!response.ok) {
    let errorMessage = "Failed to fetch campaigns.";

    try {
      const errorData = await response.json();
      errorMessage =
        errorData.detail ||
        errorData.message ||
        errorMessage;
    } catch (error) {
      // Response was not JSON
    }

    throw new Error(errorMessage);
  }

  return await response.json();
};

/*
 * ============================================================
 * GET REQUESTS / JOBS
 * ============================================================
 *
 * Backend:
 * GET /api/job-management/requests
 *
 * Used by:
 * JobsManagement.js
 */
export const getRequests = async (
  filters = {},
  onPageData
) => {
  const response = await fetch(
    `${API_URL}/api/job-management/requests`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }
  );

  if (!response.ok) {
    let errorMessage = "Failed to fetch jobs.";

    try {
      const errorData = await response.json();

      errorMessage =
        errorData.detail ||
        errorData.message ||
        errorMessage;
    } catch (error) {
      // Response was not JSON
    }

    throw new Error(errorMessage);
  }

  const responseData = await response.json();

  const requests =
    responseData.data || responseData || [];

  if (typeof onPageData === "function") {
    onPageData(
      requests,
      1,
      true
    );
  }

  return requests;
};

/*
 * ============================================================
 * ASSIGN JOBS TO CAMPAIGN
 * ============================================================
 *
 * Backend:
 * POST /api/job-management/assign
 *
 * Request:
 * {
 *   campaign_id: 19,
 *   request_ids: [10382, 10383, 10384]
 * }
 *
 * Backend will update:
 * requests.campaign_id = 19
 * for the selected request IDs.
 */
export const assignJobsToCampaign = async ({
  campaign_id,
  request_ids,
}) => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser
    ? JSON.parse(storedUser)
    : null;

  if (!user?.id) {
    throw new Error("User session not found.");
  }

  if (!campaign_id) {
    throw new Error("Campaign ID is required.");
  }

  if (!Array.isArray(request_ids) || request_ids.length === 0) {
    throw new Error("At least one job must be selected.");
  }

  const response = await fetch(
    `${API_URL}/api/job-management/assign`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-User-Id": String(user.id),
      },
      credentials: "include",
      body: JSON.stringify({
        campaign_id: Number(campaign_id),
        request_ids: request_ids.map((id) => Number(id)),
      }),
    }
  );

  if (!response.ok) {
    let errorMessage = "Failed to assign jobs.";

    try {
      const errorData = await response.json();
      errorMessage =
        errorData.detail ||
        errorData.message ||
        errorMessage;
    } catch (error) {
      // Response was not JSON
    }

    throw new Error(errorMessage);
  }

  return await response.json();
};